import { setActivityNotesData, setAllDimensions, setAllLabels, setSingleNoteData } from '../../../../features/activityNotesSlice';
import {
  setAllUsers,
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../features/userSlice";
import { activityNotesService } from "../../../../services/api/activity-notes.endpoints";
import store from "../../../../store";

async function getActivityNotes(oauthTokenHeader: any, dispatch: any) {
  try {
    const response = await activityNotesService.getActivityNotes(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get activity notes");
    } else {
      dispatch(setActivityNotesData(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function getActivityNotesContent(oauthTokenHeader: string, setRows: any) {
  try {
    const response = await activityNotesService.getActivityNotes(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setRows(response?.data?.data); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error" })
    );
  }
}

async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await activityNotesService.getAllUsers(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
};

async function getAllDimensions(oauthTokenHeader: any, dispatch: any) {
  try {
    const response = await activityNotesService.getAllDimensions(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get accuracy list");
    } else {
      dispatch(setAllDimensions(response?.data?.data));
    }
  } catch (error: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: error?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getSingleActivityNotesContent(
  oauthTokenHeader: string,
  setSingleAdvertisingAccountContent: any,
  note_shared_uid: any
) {
  try {
    const response = await activityNotesService.getSingleActivityNote(
      oauthTokenHeader,
      note_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting Page Content",
          type: "error",
        })
      );
    } else {
      setSingleAdvertisingAccountContent(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getCommentsForActivityNotes(oauthTokenHeader: any, object_shared_uid: any, setComments: any) {
  try {
    const response = await activityNotesService.getComment(oauthTokenHeader, object_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      setComments([]);
      throw new Error("Failed to get comments");
    } else {
      setComments(response?.data?.data);
    }
  } catch (e: any) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}

async function postCommentForActivityNotes(oauthTokenHeader: any, data: any, objectSharedUid: any) {
  try {
    const response = await activityNotesService.postComment(oauthTokenHeader, data, objectSharedUid);
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to post comment action items");
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Comment has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function putCommentsForActivityNotes(oauthTokenHeader: any, data: any, objectSharedUid: any) {
  try {
    const response = await activityNotesService.putComments(oauthTokenHeader, data, objectSharedUid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comment");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function deleteCommentForActivityNotes(oauthTokenHeader: any, objectSharedUid: any, commentId: any) {
  try {
    const response = await activityNotesService.deleteComment(oauthTokenHeader, objectSharedUid, commentId);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete comment");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function createNewActivityNote(oauthTokenHeader: string, data: any) {
  try {
    const response = await activityNotesService.postActivityNotes(oauthTokenHeader, data);
    if (response.status === 200) {
      return response?.data;
    } else if (response.status === 201) {
      return response?.data;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (error: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: error?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function getFilesActivityNotes(oauthTokenHeader: any, task_shared_uid: any, setFiles: any) {
  try {
    const response = await activityNotesService.getFilesItem(oauthTokenHeader, task_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
      //return response?.data?.data;
    }
  } catch (e: any) {
    // store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function uploadFileActivityNotes(oauthTokenHeader: any, data: any, object_shared_uid: any) {
  try {
    const response = await activityNotesService.fileUploadItem(oauthTokenHeader, data, object_shared_uid);
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function getSingleActivityNoteData(oauthTokenHeader: string, noteSharedUid: any, dispatch: any) {
  try {
    const response = await activityNotesService.getSingleActivityNote(oauthTokenHeader, noteSharedUid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get activity notes");
    } else {
      dispatch(setSingleNoteData(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function postActivityNotesContent(
  oauthTokenHeader: string,
  setPostedActivityNotesContent: any,
  setErrorAccToPageStatus: any,
  data: any,
  setIsLoading: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await activityNotesService.postActivityNotes(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 201) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      store.dispatch(setIsLoading(true));
      setPostedActivityNotesContent([response?.data?.data]);
      // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: "Create Successfull", type: 'success' })))
    }
  } catch (e: any) {
    // store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
  }
}
async function postComment(
  oauthTokenHeader: string,
  setCommentContent: any,
  setErrorAccToPageStatus: any,
  data: any,
  note_shared_uid: any,
  setIsLoading: any
) {
  try {
    const response = await activityNotesService.postComment(
      oauthTokenHeader,
      data,
      note_shared_uid
    );
    if (!response.status || response.status !== 200) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      store.dispatch(setIsLoading(true));
      setCommentContent([response?.data?.data]);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function updateActivityNote(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await activityNotesService.updateActivityNote(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to edit expense");
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Update Successfull",
          type: "success",
        })
      );
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getLabels(
  oauthTokenHeader: string,
  setLabelsContent: any,
  setErrorAccToPageStatus: any
) {
  try {
    const response = await activityNotesService.getLabels(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      setLabelsContent(response?.data?.data);
    }
  } catch (e: any) {
    // store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }))
  }
}

async function getAllLabels(oauthTokenHeader: string, dispatch: any) {
  try {
    const response = await activityNotesService.getLabels(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get activity notes");
    } else {
      dispatch(setAllLabels(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function getComment(
  oauthTokenHeader: string,
  note_shared_uid: any,
  setCommentContent: any,
  setErrorAccToPageStatus: any
) {
  try {
    const response = await activityNotesService.getComment(
      oauthTokenHeader,
      note_shared_uid
    );
    if (!response.status || response.status !== 200) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      setCommentContent(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function deleteActivityNote(
  oauthTokenHeader: string,
  note_shared_uid: any,
  setSuccess: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await activityNotesService.deleteActivityNote(
      oauthTokenHeader,
      note_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comments");
    } else {
      setSuccess(response?.reason);
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Delete Successfull",
          type: "success",
        })
      );
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function fileUploadME(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: string
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await activityNotesService.fileUploadME(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload file");
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getFiles(
  oauthTokenHeader: string,
  object_shared_uid: string,
  setFiles: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await activityNotesService.getFiles(
      oauthTokenHeader,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setFiles([]);
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
    }
  } catch (e: any) {
    // if(e?.status !== undefined){
    //     store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText  || 'Unknown error occurred', type: 'error' }));
    // }else {
    //     store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' }));
    // }
  }
}

async function deleteFileActivityNotes(oauthTokenHeader: any, file_shared_uid: any) {
  try {
    const response = await activityNotesService.deleteFile(oauthTokenHeader, file_shared_uid);
    if (!response || !response.status) {
      throw new Error("Failed to delete file");
    } else if (response?.status === 204) {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

// eslint-disable-next-line
export const ActivityNotesEndPointLogic = {
  getActivityNotes,
  getActivityNotesContent,
  getAllLabels,
  createNewActivityNote,
  getFilesActivityNotes,
  uploadFileActivityNotes,
  getSingleActivityNoteData,
  postActivityNotesContent,
  updateActivityNote,
  getCommentsForActivityNotes,
  postCommentForActivityNotes,
  putCommentsForActivityNotes,
  deleteCommentForActivityNotes,
  getAllUserList,
  getAllDimensions,
  getLabels,
  postComment,
  getComment,
  fileUploadME,
  deleteActivityNote,
  getFiles,
  getSingleActivityNotesContent,
  deleteFileActivityNotes
};
